import { render, staticRenderFns } from "./edit-tsm-number.vue?vue&type=template&id=42fad51e&scoped=true"
import script from "./edit-tsm-number.vue?vue&type=script&lang=js"
export * from "./edit-tsm-number.vue?vue&type=script&lang=js"
import style0 from "./edit-tsm-number.vue?vue&type=style&index=0&id=42fad51e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fad51e",
  null
  
)

export default component.exports